import { registerIcons } from '@uifabric/styling';
import { Promise } from 'es6-promise';
import { createHashHistory } from "history";
import { action, computed, observable } from "mobx";
import { IObservableArray } from "mobx/lib/types/observablearray";
import * as React from "react";
import { DownIcon } from '../Icons/DownIcon';
import * as PortalManagement from "../PortalManagement";
import * as UiInfo from "../States/AreaUiInfo";
import { DialogResult, DialogStore } from "../Stores/DialogStore";
import { Strings } from "../Stores/StringsStore";
import { string } from 'prop-types';


class NamePath {
    name: string;
    path: string;
}

export class AreaStore {
    @observable currentFocusedItem: string;
    @observable isEditMode: boolean = false;
    @observable isBusy: boolean = false;
}

export interface IWizardStore {
    onConfirmWizard: () => void;
    onCancelWizard: () => void;
    open: () => void;
    wizardCaption: string;
    wizardInformation: string;
    wizardWarningText: string;
    wizardWarning: boolean;
    isWizardBoxBusy: boolean;
    confirmEnabled: boolean;
}

export class WizardStore {
    @observable isOpen: boolean = false;
    @observable wizardCaption: string = "";
    @observable wizardInformation: string = "";
    @observable wizardWarningText: string = "";
    @observable wizardWarning: boolean = false;
    @observable isWizardBoxBusy: boolean = false;
    @observable confirmEnabled: boolean = true;
}

export interface IWizardState {
    onConfirmWizard: () => void;
    onCancelWizard: () => void;
    wizardCaption: string;
    wizardInformation: string;
    wizardWarningText: string;
    wizardWarning: boolean;
    isWizardBoxBusy: boolean;
}

class UiSettingsStoreImpl {
    collectionsUiInfo: UiInfo.AreaUiInfoImpl = new UiInfo.AreaUiInfoImpl();
    userUiInfo: UiInfo.AreaUiInfoImpl = new UiInfo.AreaUiInfoImpl();
    userGroupsUiInfo: UiInfo.AreaUiInfoImpl = new UiInfo.AreaUiInfoImpl();
    metaUiInfo: UiInfo.AreaUiInfoImpl = new UiInfo.AreaUiInfoImpl();
    portalUiInfo: UiInfo.AreaUiInfoImpl = new UiInfo.AreaUiInfoImpl();
}

class AppStoreImpl {
    constructor() {
        this._title = "CDP";
    }

    @observable context: PortalManagement.ApplicationContext = new PortalManagement.ApplicationContext();
    @observable portals: PortalManagement.PortalInfo[] = [];
    //collectionsUiInfo: UiInfo.AreaUiInfoImpl;
    //userUiInfo: UiInfo.AreaUiInfoImpl;
    //userGroupsUiInfo: UiInfo.AreaUiInfoImpl;
    //metaUiInfo: UiInfo.AreaUiInfoImpl;
    //portalUiInfo: UiInfo.AreaUiInfoImpl;

    UiSettingsStore: UiSettingsStoreImpl = new UiSettingsStoreImpl();

    @observable metaComponentIsInMoveMode: boolean = false;

    @observable isBusyModelLoading: boolean = true;

    isDirtyChange: boolean = false;
    isDirtyMode: boolean = false;
    saveOnLeave: (onSaveCompleted: () => void) => void;

    @observable private _title: string;

    @observable history = createHashHistory();

    previousPaths: IObservableArray<string> = observable.array<string>();

    @observable isBusy: boolean = false;
    @observable isSystemOnline: boolean = true;

    @computed get title(): string {
        return this._title;
    }

    @action keepOnPage = (url: string, isPush: boolean = false, action?: Function, isAddDocument: boolean = false) => {
        if (this.isDirtyChange && !this.isDirtyMode && !AppStore.isBusyModelLoading) {
            DialogStore.showDeleteConfirmation(Strings.general.onLeaveDialogTitle, Strings.general.onLeaveDialogText).then((result: DialogResult) => {
                if (result == DialogResult.Yes) {
                    this.isDirtyChange = false;
                    if (isPush) {
                        this.previousPaths.push(url);
                        this.history.push(url);
                    }
                    else {
                        this.previousPaths.pop();
                        this.previousPaths.push(url);
                        this.history.replace(url);
                    }
                    if (action) {
                        action();
                    }
                }
            });
        }
        else if (this.isDirtyMode && this.isDirtyChange && isAddDocument && !AppStore.isBusyModelLoading) {
            DialogStore.show(Strings.general.keepOnPageDialogTitle, Strings.general.keepOnPageDialogText).then((result: DialogResult) => {
                if (result == DialogResult.Yes) {
                    this.saveOnConfirmation(isPush, url, action);
                }
                else if (result == DialogResult.No) {
                    this.isDirtyMode = true;
                    this.isDirtyChange = true;
                    if (action) {
                        action();
                    }
                }
            });
        }
        else if (this.isDirtyMode && this.isDirtyChange && !AppStore.isBusyModelLoading) {
            DialogStore.show(Strings.general.keepOnPageDialogTitle, Strings.general.keepOnPageDialogText).then((result: DialogResult) => {
                if (result == DialogResult.Yes) {
                    this.saveOnConfirmation(isPush, url, action);
                }

                else if (result == DialogResult.No) {
                    this.isDirtyMode = false;
                    this.isDirtyChange = false;
                    if (isPush) {
                        this.previousPaths.push(url);
                        this.history.push(url);
                    }
                    else {
                        this.previousPaths.pop();
                        this.previousPaths.push(url);
                        this.history.replace(url);
                    }
                    if (action) {
                        action();
                    }
                }
            });
        }
        else {
            this.isDirtyMode = false;
            this.isDirtyChange = false;
            if (isPush) {
                this.previousPaths.push(url);
                this.history.push(url);
            }
            else {
                this.previousPaths.pop();
                this.previousPaths.push(url);
                this.history.replace(url);
            }
            if (action) {
                action();
            }
        }
    }
    saveOnConfirmation(isPush: boolean, url: string, action?: Function) {
        this.isDirtyMode = false;
        this.isDirtyChange = false;
        this.saveOnLeave(() => {
            this.saveOnLeave = null;
            if (isPush) {
                this.previousPaths.push(url);
                this.history.push(url);
            }
            else {
                this.previousPaths.pop();
                this.previousPaths.push(url);
                this.history.replace(url);
            }
        });
        if (action) {
            action();
        }
    }

    @action keepOnPageRedirect = (e: BeforeUnloadEvent) => {
        if ((this.isDirtyMode || this.isDirtyChange) && !AppStore.isBusyModelLoading) {
            e.preventDefault();
            let dialogText = Strings.general.keepOnPageDialogText;
            e.returnValue = dialogText;
            return dialogText;
        }
        else {
            return undefined;
        }
    }

    @action goBack = () => {
        if (this.isDirtyChange && !this.isDirtyMode && !AppStore.isBusyModelLoading) {
            DialogStore.showDeleteConfirmation(Strings.general.onLeaveDialogTitle, Strings.general.onLeaveDialogText).then((result: DialogResult) => {
                if (result == DialogResult.Yes) {
                    this.isDirtyChange = false;
                    this.previousPaths.pop();
                    this.history.goBack();
                }
            });
        }
        else if (this.isDirtyMode && this.isDirtyChange && !AppStore.isBusyModelLoading) {
            DialogStore.show(Strings.general.keepOnPageDialogTitle, Strings.general.keepOnPageDialogText).then((result: DialogResult) => {
                if (result == DialogResult.Yes) {
                    this.isDirtyMode = false;
                    this.isDirtyChange = false;
                    this.saveOnLeave(() => {
                        this.saveOnLeave = null;
                        this.previousPaths.pop();
                        this.history.goBack();
                    });
                }
                else if (result == DialogResult.No) {
                    this.isDirtyMode = false;
                    this.isDirtyChange = false;
                    this.previousPaths.pop();
                    this.history.goBack();
                }
            });
        }
        else {
            this.isDirtyMode = false;
            this.isDirtyChange = false;
            const popedUrl: string = this.previousPaths.pop();
            if (popedUrl.endsWith(".epub")) {
                const previousUrl: string = this.previousPaths[this.previousPaths.length - 1] != undefined
                    ? this.previousPaths[this.previousPaths.length - 1]
                    : "/";
                this.history.replace(previousUrl);
            }
            else {
                this.history.goBack();
            }
        }
    }


    @action public setTitle(title: string) {
        this._title = title;
        document.getElementsByTagName("title")[0].text = this.title;
    }

    init(): Promise<void> {
        // HACK to force load with Internet Explorer. This "unlocks" the blocked promises
        let intervalHandle = setInterval(() => { }, 100);

        registerIcons({
            icons: {
                'up': <DownIcon />,
                'down': <DownIcon />,
                'calendar': null
            }
        });

        return new Promise<void>((resolve: () => void, reject: (error: any) => void) => {
            PortalManagement.getApplicationContextAsync().then(context => {
                this.context = context;

                Strings.load(context.sessionDetails.uiLanguage).then(() => {
                    if (!context.portalSettings.isValid) {
                        DialogStore.showError(Strings.general.errorDialogTitle, context.portalSettings.validationMessage);
                    }
                    clearInterval(intervalHandle);
                    resolve();
                });
            });
        });
    }

    updatePortals(): Promise<void> {
        return new Promise<void>((resolve: () => void, reject: (error: any) => void) => {
            PortalManagement.getPortalInfosAsync().then(portals => {
                this.portals = portals;
                resolve();
            }).catch((error: any) => reject(error))
        });
    }


    pathArray: NamePath[] = [];

    savePath(path: string) {

        if (path[0] == '#') {
            path = path.substr(1);
        }
        let j = path.indexOf("?");
        if (j > 0) {
            path = path.substr(0, j);
        }

        let name = path.split("/")[1];

        let item: NamePath = null;
        for (let i = 0; i < this.pathArray.length; i++) {
            let item2 = this.pathArray[i];
            if (item2.name == name) {
                item = item2;
                break;
            }
        }

        if (item == null) {
            item = new NamePath();
            item.name = name;
            this.pathArray.push(item);
        }
        item.path = path;
    }

    getPath(name: string): string {
        for (let i = 0; i < this.pathArray.length; i++) {
            let item = this.pathArray[i];
            if (item.name == name) {
                return item.path;
            }
        }
        return null;
    }


}

export var AppStore = new AppStoreImpl();
